<template>
  <div class="confirm">
    <div class="fr ac jsb mb10">
      <p class="fz14 black bold">选择收货地址</p>
      <el-button
          size="mini"
          class="mt10"
          type="text"
          @click=" editAddress({})"
      >添加地址
      </el-button
      >
    </div>
    <div class="header fr afs">
      <p class="fz14 black bold mr10">寄送至:</p>
      <div v-if="address_list.length" class="fc afs">
        <!-- 只显示默认地址 -->
        <el-radio-group v-model="selectAddressId" v-if="!more">
          <el-radio
              :label="address_list[default_address].address_id"
              class="fr ac"
          >
            <div class="fr ac jsb ml20">
              <p>{{ address_list[default_address].address_name }}</p>
              <p class="ml20">
                {{ formatPhone(address_list[default_address].address_mobile) }}
              </p>
              <p class="ml20">
                <span>{{
                    address_list[default_address].address_province
                  }}</span>
                <span>{{ address_list[default_address].address_city }}</span>
                <span>{{ address_list[default_address].address_country }}</span>
                <span>{{
                    address_list[default_address].address_detailed
                  }}</span>
              </p>
              <el-button
                  type="text"
                  class="ml20"
                  @click.prevent="editAddress(address_list[default_address])"
              >修改地址
              </el-button>
            </div>
          </el-radio>
        </el-radio-group>
        <!-- 所有地址 -->
        <el-radio-group
            v-model="selectAddressId"
            class="fc radio_group"
            @change="more = false"
            v-infinite-scroll="getMemberAddress"
            infinite-scroll-disabled="address_finished"
            v-else
        >
          <el-radio
              :label="i.address_id"
              v-for="(i, k) in address_list"
              :key="i.address_id"
              class="fr ac mb20"
              @click.native="default_address = k"
          >
            <div class="fr ac jsb ml20">
              <p>{{ i.address_name }}</p>
              <p class="ml20">{{ formatPhone(i.address_mobile) }}</p>
              <p class="ml20">
                <span>{{ i.address_province }}</span>
                <span>{{ i.address_city }}</span>
                <span>{{ i.address_country }}</span>
                <span>{{ i.address_detailed }}</span>
              </p>
              <el-button
                  type="text"
                  class="ml20 btns"
                  @click.prevent="editAddress(i)"
              >修改地址
              </el-button>
            </div>
          </el-radio>
        </el-radio-group>
        <div v-if="address_list.length > 1">
          <el-button
              type="text"
              class="black"
              @click="more = !more"
              v-if="!more"
          >
            更多地址
            <i class="el-icon-d-arrow-right"></i>
          </el-button>
          <el-button type="text" class="black" @click="more = !more" v-else>
            收起地址
            <i class="el-icon-d-arrow-left"></i>
          </el-button>
        </div>
      </div>
    </div>
    <!-- 订单信息 -->
    <div class="main">
      <p class="fz14 black bold pb10">确认订单信息</p>
      <!-- 订单信息 -->
      <el-table :data="cart_info" tooltip-effect="dark" style="width: 100%">
        <el-table-column label="产品信息" width="400">
          <template slot-scope="scope">
            <div class="fr afs">
              <img
                  :src="scope.row.goods_img"
                  class="goods_img"
                  preview="0"
                  alt
              />
              <div class="ml10">
                <p class="fz12 ellipsis-2line"> {{ scope.row.goods_name }} </p>
                <p class="fz12 ellipsis-2line"> ￥{{ scope.row.goods_price }} </p>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="产品规格">
          <template slot-scope="scope">
            <span>{{ specNameInit(scope.row, 'specification_inputs') }}</span>
            <!--            <span class="fz12" v-if="scope.row.goods_type == 1"-->
            <!--            >{{ Number(scope.row.goods_length) }}m×{{-->
            <!--                Number(scope.row.goods_width)-->
            <!--              }}m</span>-->
            <!--            <span v-if="scope.row.goods_type == 2">{{-->
            <!--                scope.row.specification_name-->
            <!--              }}</span>-->
          </template>
        </el-table-column>
        <el-table-column prop="device_name" label="设备信息"></el-table-column>
        <el-table-column prop="car_num" label="数量"></el-table-column>
      </el-table>
      <!-- 发票信息 -->
      <div class="remark">
        <el-checkbox v-model="checked">开具发票</el-checkbox>
        <div v-if="checked" class="fz14 black fr mt20">
          <p>
            {{ invoice_json.invoice_type == "1" ? "增值税普票" : "增值票专票" }}
          </p>
          <p class="ml10">{{ invoice_json.invoice_name }}</p>
          <el-button
              type="text"
              class="invoice_btn ml10"
              @click="add_invoice_visible = true;type = 'edit';">修改发票
          </el-button>
          <el-button
              type="text"
              class="invoice_btn"
              @click.native="invoice_visible = true"
          >选择发票
          </el-button>
          <el-button
              type="text"
              class="invoice_btn"
              @click="add_invoice_visible = true;type = 'add';"
          >新增发票
          </el-button>
        </div>
      </div>
      <!-- 内部订单信息 -->
      <div class="order_info">
        <div class="fr ac mb10">
          <p class="fz14 black title">客户内部订单号:</p>
          <el-input
              v-model="vip_order_no"
              clearable
              size="mini"
              class="ml20"
          ></el-input>
        </div>
        <div class="fr ac">
          <p class="fz14 black fs title">客户内部备注图片:</p>
          <up-load :file_list="vip_order_imgs" :limit="6"/>
        </div>
      </div>
      <div class="remark">
        <div class="fr ac mb10">
          <p class="fz14 black fs" style="width: 8%">备注：</p>
          <el-input
              v-model="order_remark"
              clearable
              size="mini"
              rows="4"
              type="textarea"
              resize="none"
              class="ml20"
          ></el-input>
        </div>
      </div>
    </div>
    <!-- 底部提交 -->
    <div class="footer fc afe">
      <div class="submit_box fc afe">
        <div class="top">
          <p class="blue fz18 bold"> 总价:￥{{ total_price }} </p>
          <p class="blue fz14 mt10 bold" v-if="!is_Empty(order_machinery_manufacturers_discount_price)">
            厂商优惠:￥{{ order_machinery_manufacturers_discount_price }} </p>
          <p class="fz14 black mt20" v-if="address_list.length">
            <span class="fz14 black bold">寄送至:</span>
            <span>{{ address_list[default_address].address_province }}</span>
            <span>{{ address_list[default_address].address_city }}</span>
            <span>{{ address_list[default_address].address_country }}</span>
            <span>{{ address_list[default_address].address_detailed }}</span>
          </p>
          <p class="fz14 black mt20" v-if="address_list.length">
            <span class="fz14 black bold">寄送至:</span>
            <span>{{ address_list[default_address].address_name }}</span>
            <span class="ml20">{{
                formatPhone(address_list[default_address].address_mobile)
              }}</span>
          </p>
        </div>


        <el-button
            class="submit_btn"
            type="primary"
            @click="submit"
            :disabled="is_summit == '1'"
        >提交订单
        </el-button>
      </div>
      <!-- <p class="fz14 grey mt10">注：订单提交后需等待销售审核，清注意查看订单状态</p> -->
      <!-- <p class="fz14 grey mt10">注：订单交货日期由销售与您协商确认</p> -->
    </div>
    <!-- 修改 or 添加 -->
    <address-add
        :addressVisible.sync="addressVisible"
        @success="getMemberAddress"
        :type="type"
        :info="info"
    />
    <select-invoice
        :invoiceVisible.sync="invoice_visible"
        @selectInvoice="invoiceClick"
    />
    <add-invoice
        :invoiceVisible.sync="add_invoice_visible"
        @cloneVisible="invoiceClick"
        :type="type"
        :info="invoice_json"
    />
  </div>
</template>

<script>
import UpLoad from "@/components/UploadImg";
import Add from "@/components/HandleAddress";
import SelectInvoice from "@/components/SelectInvoice";
import AddInvoice from "@/components/AddInvoice";

export default {
  data() {
    return {
      addressVisible: false, //新增收货地址是否显示
      invoice_visible: false, //发票是否显示
      add_invoice_visible: false, //新增发票是否显示
      checked: false, //是否开具发票
      more: false, //更多地址
      cart_info: [],
      default_address: 0,
      selectAddressId: null,
      address_list: [], //地址列表
      address_finished: false, //是否加载完成
      vip_order_no: "", //客户内部订单号
      vip_order_imgs: [], //客户内部备注图片
      order_remark: "", //备注
      order_machinery_manufacturers_discount_price: "", //厂商优惠金额
      total_price: "0", //总价
      is_summit: "0", //是否提交订单
      invoice_json: {},
      type: "add",
      info: {},
    };
  },
  created() {
    this.cart_info = this.$store.state.insertOrder;
    this.getMemberAddress();
    this.getDefaultInvoice();
    this.checkoutV2();
  },
  watch: {},
  methods: {
    spliceData() {
      let obj = {};
      obj.order_remark = this.order_remark;
      obj.vip_order_no = this.vip_order_no;
      obj.vip_order_imgs = this.vip_order_imgs.join(",");
      obj.is_summit = this.is_summit;
      obj.address_id = this.selectAddressId;
      if (this.checked) obj.invoice_id = this.invoice_json.invoice_id;
      obj.is_invoice = this.checked ? "1" : "0";
      //如果是销售代客下单，type传2 客户自主下单传1
      obj.checkout_type = (!this.is_Empty(this.$store.state.sale_info) || this.$store.state.is_sales) ? 2 : 1
      obj.orderGoodsBeans = [];
      let arr = [];
      this.cart_info.forEach(el => {
        arr.push(el.car_id);
        let obj1 = {};
        obj1.goods_id = el.goods_id;
        obj1.shop_id = el.shop_id;
        obj1.drawings = el.drawings;
        obj1.specification_id = el.specification_id;
        obj1.goods_num = el.car_num;
        obj1.company_device_id = el.company_device_id || "";
        obj1.company_device_position_id = el.company_device_position_id || "";
        obj1.orderCraftBeans = el.crafts || [];
        obj1.company_requirement_json = el.company_requirement_json || [];
        obj1.orderGoodsSpecificationInputBeans = el.specification_inputs;
        obj1.craft_remark = el.craft_remark;
        obj.orderGoodsBeans.push(obj1);
      })
      obj.car_ids = arr.join(",");
      return obj;
    },
    editAddress(info) {
      this.info = JSON.parse(JSON.stringify(info));
      this.addressVisible = true;
    },
    // 选择发票
    invoiceClick(obj) {
      if (!this.is_Empty(obj)) {
        this.invoice_json = obj;
      }
      this.type = "add";
      this.invoice_visible = false;
      this.add_invoice_visible = false;
    },

    // 获取地址列表
    getMemberAddress() {

      this.post("addressInterfaces/v1.0/getMemberAddress", {
        page: -1,
        pageSize: -1,
        address_type: 1
      }).then((res) => {
        this.selectAddressId = res.data[0].address_id;
        this.address_list = res.data;
      });
    },
    // 获取默认发票
    getDefaultInvoice() {
      this.post("/invoiceInterfaces/v1.0/getDefaultInvoice").then((res) => {
        if (!this.is_Empty(res.data)) {
          this.invoice_json = res.data;
          this.checked = true;
        }
      });
    },
    submit() {
      this.is_summit = "1";
      this.insertOrder();
    },
    checkoutV2() {

      this.post("orderInterfaces/v1.0/checkout", {
        order_json: JSON.stringify(this.spliceData()),
        //如果是销售代客下单，type传2 客户自主下单传1
        checkout_type: (!this.is_Empty(this.$store.state.sale_info) || this.$store.state.is_sales) ? 2 : 1
      }).then((res) => {
        this.total_price = res.data.order_actual_price;
        this.order_machinery_manufacturers_discount_price = res.data.order_machinery_manufacturers_discount_price;
      });
    },
    // 添加订单
    insertOrder() {

      let params = this.spliceData();

      params.json = JSON.stringify(params.orderGoodsBeans);
      delete params.orderGoodsBeans;
      this.post("orderInterfaces/v1.0/insertOrder", params).then((res) => {
        if (res.status === "ok") {
          this.$message({
            message: "订单已提交审核请等待审核结果。",
            type: "success",
          });
          setTimeout(() => {
            this.$store.commit('setInsertOrder', []);
            this.redirect('/')
          }, 3000);
        }
      });
    },
  },
  components: {
    "up-load": UpLoad,
    "address-add": Add,
    SelectInvoice,
    AddInvoice,
  },
};
</script>

<style lang="scss">
.confirm {
  width: 1200px;
  margin: 0 auto;
  padding: 20px 0;

  .btns {
    padding: 0;
  }

  .title {
    width: 120px;
  }

  .header {
    width: 100%;
    background-color: #fff;
    padding: 20px;
    padding-left: 5%;

    .radio_group {
      max-height: 120px;
      overflow-y: scroll;
    }

    .el-icon-d-arrow-right {
      transform: rotate(90deg);
    }

    .el-icon-d-arrow-left {
      transform: rotate(90deg);
    }
  }

  .main {
    width: 100%;
    background-color: #fff;
    margin-top: 20px;
    padding: 20px;

    .el-table {
      .el-table__header-wrapper {
        .cell {
          text-align: center;
        }
      }

      .goods_img {
        width: 60px;
        height: 60px;
        flex-shrink: 0;
      }

      .el-table__row {
        .cell {
          text-align: center;
        }
      }
    }

    .order_info {
      padding: 20px;
      margin-top: 20px;
      width: 100%;
      min-height: 149px;
      background: rgba(240, 246, 255, 1);

      .el-input {
        width: 200px;
      }

      .img-item {
        img {
          width: 100px;
          height: 100px;
        }
      }

      .el-upload {
        width: 100px;
        height: 100px;
        display: flex;
        justify-content: center;
        align-items: center;

        .el-upload__input {
          width: 100%;
          height: 100%;
        }
      }
    }

    .remark {
      width: 100%;
      padding: 20px;
      margin-top: 20px;
      background: rgba(240, 246, 255, 1);

      .el-textarea {
        width: 40%;
      }

      .invoice_btn {
        padding: 0;
      }
    }
  }

  .footer {
    width: 100%;
    margin-top: 20px;

    .submit_box {
      .top {
        text-align: right;
        width: 570px;
        height: 140px;
        padding: 20px;
        background: rgba(255, 255, 255, 1);
        border: 4px solid rgba(69, 142, 246, 1);
      }

      .submit_btn {
        width: 30%;
        border-radius: 0;
      }
    }
  }

  .el-dialog {
    .el-dialog__header {
      background-color: #eaeaea;
      height: 40px;
      padding: 0 20px;

      .head {
        height: 100%;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/homePage/confirmOrder/index.vue